module.exports = __webpack_public_path__ + "static/media/QuarterView.c5a83b9d.svg";